/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from '../constants/routes';
import { ICONS } from '../constants/icons';

const activitiesTabsPages = [
  ROUTES.HOME_CAFE,
  ROUTES.BETTING_JACKPOT,
  ROUTES.HOME_BETTING,
  ROUTES.BETTING_TASKS,
  ROUTES.FREE_TO_PLAY,
  ROUTES.FREE_TO_PLAY_TICKETS_DETAILS,
];
const bettingTabsPages = [
  ROUTES.BETTING_JACKPOT,
  ROUTES.BETTING_TASKS,
  ROUTES.FREE_TO_PLAY,
];
const historyTabsPages = [ROUTES.TRANSACTION_HISTORY];
const vouchersTabsPages = [ROUTES.МАX_VOUCHERS];
const freeToPlayTabsPages = [ROUTES.FREE_TO_PLAY];
const bettingTasksTabsPages = [ROUTES.BETTING_TASKS];
const jackpotTabsPages = [ROUTES.BETTING_JACKPOT];
const shopTabsPages = [
  'max-prodavnica',
  'dodaj-u-korpu',
  'moja-korpa',
  'podaci-za-slanje',
  'potvrda-za-slanje',
];
const navigationPages = [ROUTES.PROFILE];
const aboutTabsPages = [ROUTES.ABOUT_APP];
@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  currentNavBar:
    | {
        title: string;
        imageURL: any;
        pageUrlSegment: string;
        hasInfo: boolean;
        infoMessage: string;
        otherIcon: string | undefined;
      }
    | undefined;

  navBarsWithTitles = [
    {
      title: 'Pregled transakcija',
      imageURL: ICONS.HEADER_HISTORY,
      pageUrlSegment: ROUTES.TRANSACTION_HISTORY,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Pregled isteklih MBC bodova',
      imageURL: ICONS.HEADER_HISTORY,
      pageUrlSegment: ROUTES.TRANSACTION_HISTORY,
      hasInfo: true,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Promo',
      imageURL: ICONS.HEADER_PROMO,
      pageUrlSegment: ROUTES.PROMO,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Skeniranje',
      imageURL: ICONS.HEADER_SCANNER,
      pageUrlSegment: ROUTES.QR_SCANNER_CAMERA,
      hasInfo: true,
      infoMessage:
        'Osvoji MaxBet Coin bodove lojalnosti skeniranjem QR koda sa nefiskalnog isečka računa u  MaxCafé. Učestvuj u izvlačenju za MaxLoyalty Jackpot skeniranjem MaxLoyalty QR koda na odigranom tiketu.',
      otherIcon: undefined,
    },
    {
      title: 'Ručni unos',
      imageURL: ICONS.HEADER_MANUAL_ENTRY,
      pageUrlSegment: ROUTES.QR_SCANNER_MANUAL_ENTRY,
      hasInfo: true,
      infoMessage:
        'Ručno unesi broj i vreme izdavanja tiketa u MaxBet lokalu, ili PFR broj i vreme izdavanja računa iz MaxCafé, i učestvuj u MaxLoyalty programu.',
      otherIcon: undefined,
    },
    {
      title: 'MaxLoyalty kartica',
      imageURL: ICONS.HEADER_CARD,
      pageUrlSegment: ROUTES.BAR_CODE,
      hasInfo: true,
      infoMessage:
        'Prilikom plaćanja računa pokaži svoj lični bar kod operateru u bilo kom MaxBet lokalu i iskoristi sakupljene bodove za plaćanje dela ili računa u celosti.',
      otherIcon: undefined,
    },
    {
      title: 'Lični podaci',
      imageURL: ICONS.PROFILE,
      pageUrlSegment: ROUTES.MY_PROFILE,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Pravila igre',
      imageURL: ICONS.HEADER_GAME_RULES,
      pageUrlSegment: ROUTES.GAME_RULES,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'O aplikaciji',
      imageURL: ICONS.HEADER_ABOUT_APP,
      pageUrlSegment: ROUTES.ABOUT_APP,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Uslovi i Politika privatnosti',
      imageURL: ICONS.TERMS_AND_CONDITIONS,
      pageUrlSegment: ROUTES.TERMS_AND_CONDITIONS,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Korisnička podrška',
      imageURL: ICONS.HEADER_SUPPORT,
      pageUrlSegment: ROUTES.SUPPORT,
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Maxshop',
      imageURL: ICONS.HEADER_SHOPPING_BAG,
      pageUrlSegment: ROUTES.МАX_SHOP,
      hasInfo: false,
      infoMessage: '',
      otherIcon: ICONS.SHOPPING_CART_GRAY,
    },
    {
      title: 'Maxshop',
      imageURL: ICONS.SHOPPING_PRODUCT_INFO,
      pageUrlSegment: 'dodaj-u-korpu',
      hasInfo: false,
      infoMessage: '',
      otherIcon: ICONS.SHOPPING_CART_GRAY,
    },
    {
      title: 'Maxshop',
      imageURL: ICONS.SHOPPING_CART_GRAY,
      pageUrlSegment: 'moja-korpa',
      hasInfo: true,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Podaci za slanje',
      imageURL: ICONS.SHOPPING_ORDERS,
      pageUrlSegment: 'podaci-za-slanje',
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
    {
      title: 'Potvrda za slanje',
      imageURL: ICONS.SHOPPING_CART_CONFIRM_ORDER,
      pageUrlSegment: 'potvrda-za-slanje',
      hasInfo: false,
      infoMessage: '',
      otherIcon: undefined,
    },
  ];

  constructor(private router: Router) {}

  isNavigationBackVisible(): boolean {
    return !this.isActivitiesTabsVisible();
  }

  isNavigationVisible(): boolean {
    const decodedUrl = decodeURIComponent(this.router.url);
    return navigationPages.some((value) => decodedUrl.includes(value));
  }

  isHistoryTabsVisible(): boolean {
    return historyTabsPages.includes(this.getLastUrlSegment());
  }

  isActivitiesTabsVisible(): boolean {
    const decodedUrl = decodeURIComponent(this.router.url);
    return activitiesTabsPages.some((value) => decodedUrl.includes(value));
  }

  isVoucherTabsVisible(): boolean {
    const decodedUrl = decodeURIComponent(this.router.url);
    return (
      !decodedUrl.includes('detalji') &&
      vouchersTabsPages.some((value) => decodedUrl.includes(value))
    );
  }

  isFreeToPlayTabsVisible(): boolean {
    const decodedUrl = decodeURIComponent(this.router.url);
    return freeToPlayTabsPages.some((value) => decodedUrl.includes(value));
  }

  isTabComponentVisible() {
    const lastSegmentOfCurrentUrl = this.getLastUrlSegment();
    return (
      vouchersTabsPages.includes(lastSegmentOfCurrentUrl) ||
      activitiesTabsPages.includes(lastSegmentOfCurrentUrl)
    );
  }

  isAboutPageVisible() {
    return aboutTabsPages.includes(this.getLastUrlSegment());
  }

  isBettingTasksTabsVisible() {
    const decodedUrl = decodeURIComponent(this.router.url);
    return bettingTasksTabsPages.some((value) => decodedUrl.includes(value));
  }

  isJackpotTabsVisible() {
    return jackpotTabsPages.includes(this.getLastUrlSegment());
  }

  isBettingTabActive() {
    const decodedUrl = decodeURIComponent(this.router.url);
    return bettingTabsPages.some((value) => decodedUrl.includes(value));
  }

  isShopTabsVisible() {
    const decodedUrl = decodeURIComponent(this.router.url);
    return shopTabsPages.some((value) => decodedUrl.includes(value));
  }

  decodeUrl(currentUrl: string): string {
    const decodedUrl = decodeURIComponent(currentUrl);
    const segments = decodedUrl.split('/');
    const lastSegment = segments[1];
    return lastSegment;
  }

  getLastUrlSegment() {
    const decodedUrl = decodeURIComponent(this.router.url);
    const segments = decodedUrl.split('/');

    return segments[segments.length - 1];
  }

  setCurrentNavBar() {
    let decodedUrl = decodeURIComponent(this.router.url).slice(1);
    const urlSegments = decodedUrl.split('/');

    if (urlSegments.length > 1) {
      decodedUrl = urlSegments[1];
    }
    this.currentNavBar = this.navBarsWithTitles.find(
      (page: { pageUrlSegment: string | string[] }) =>
        page.pageUrlSegment.includes(decodedUrl)
    );
  }

  setCurrentNavBarInfo(title: any, imageUrl: any) {
    this.currentNavBar!.title = title;
    this.currentNavBar!.imageURL = imageUrl;
  }
}
